module.exports = __webpack_public_path__ + "static/media/icon_lightorange.dccac392.svg";